import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	list: [],
	distributorsFetched: false,
};

const distributorsSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setDistributorsData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},
		setLoadingDistributors: (state, action) => {
			state.loading = action.payload;
		},
		setAllDistributorsList: (state, action) => {
			const { data } = action.payload;
			state.list = data || [];
			state.distributorsFetched = true;
		},
		setAllDistributorsListMore: (state, action) => {
			const data = action.payload;
			state.list = data || [];
		},
	},
});

export const {
	setDistributorsData,
	setLoadingDistributors,
	setAllDistributorsList,
	setAllDistributorsListMore,
} = distributorsSlice.actions;
export default distributorsSlice.reducer;
